import { useMemo } from 'react';
import { useAppSelector } from 'app/hooks';
import { currencyFormatter } from 'util/locale';
import { formatNumSeedBags } from 'util/formatters/numberFormatter';
import { getCurrency } from 'user/userSelectors';
import { RecommendationTableRow } from './types';
import { useParseRecommendationRows } from './useParseRecommendationRows';
import { FieldData } from '../../types';

export const useReviewPlanRows = (field: FieldData): RecommendationTableRow[] => {
  const currency = useAppSelector(getCurrency);
  const { fvssRow, yourEntryRow } = useParseRecommendationRows(field);

  const data = useMemo(() => {
    const deltaValue = fvssRow?.projectedRevenuePerArea - yourEntryRow?.projectedRevenuePerArea;
    return (fvssRow && yourEntryRow)
      ? [fvssRow, yourEntryRow].map((row, index) => ({
        id: row.id,
        pop: row.avgFixedPop,
        yield: row.estimatedYield,
        bags: formatNumSeedBags(row.bagsNeeded),
        seedCost: currencyFormatter(row.seedCostPerArea, currency, { round: true }),
        revenue: currencyFormatter(row.projectedRevenuePerArea, currency, { round: true }),
        delta: index === 0 ? deltaValue : -deltaValue,
        isPreferredPlan: row?.isPreferredPlan
      }))
      : [];
  }, [fvssRow, yourEntryRow, currency]);

  return data;
};
